import { actionCreator } from "./helpers";
import { callApi } from "./Api";

export const SHOW_LOGIN_DIALOG = "SHOW_LOGIN_DIALOG";
export const CLOSE_LOGIN_DIALOG = "CLOSE_LOGIN_DIALOG";
export const SET_EMAIL = "SET_EMAIL";
export const SET_PASSWORD = "SET_PASSWORD";
export const MOUNT_SESSION = "MOUNT_SESSION";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SESSION = "SESSION";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const SHOW_FORGOT_PASSWORD = "SHOW_FORGOT_PASSWORD";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const USER_CLIENTS = "USER_CLIENTS";
export const USER_AVATAR = "USER_AVATAR";
export const LOGIN_USER_DETAIL = "LOGIN_USER_DETAIL";
export const OPTIMIZE_USER_DETAIL = "OPTIMIZE_USER_DETAIL";
export const SELECT_CLIENT = "SELECT_CLIENT";
export const SEND_PASSWORD_RECOVERY = "SEND_PASSWORD_RECOVERY";
export const GET_API_BUILD_NUMBER = "GET_API_GUILD_NUMBER";
export const GET_CLIENT_BYID = "GET_CLIENT_BYID";
export const CLEAR_CLIENT_INFO = "CLEAR_CLIENT_INFO";
export const GET_DISABLED_FEATURES = "GET_DISABLED_FEATURES";
export const SET_LOGIN_ERROR_MESSAGE = "SET_LOGIN_ERROR_MESSAGE";

export const mountSession = actionCreator(MOUNT_SESSION);
export const showLoginDialog = actionCreator(SHOW_LOGIN_DIALOG);
export const closeLoginDialog = actionCreator(CLOSE_LOGIN_DIALOG);
export const setEmail = actionCreator(SET_EMAIL);
export const setPassword = actionCreator(SET_PASSWORD);
export const logout = actionCreator(LOGOUT);
export const showForgotPassword = actionCreator(SHOW_FORGOT_PASSWORD);
export const selectClient = actionCreator(SELECT_CLIENT);
export const clearClientInfo = actionCreator(CLEAR_CLIENT_INFO);
export const setLoginErrorMessage = actionCreator(SET_LOGIN_ERROR_MESSAGE);

export const getDisabledFeatures = () => {
  return (dispatch, getState) => {
    callApi(
      dispatch,
      getState,
      GET_DISABLED_FEATURES,
      `auth/disabled-features`,
    );
  };
};

export const getAPIBuildNumber = () => {
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_API_BUILD_NUMBER, `proxy/build-number`);
  };
};

export const sendLogin = (e, p) => {
  return (dispatch, getState) => {
    callApi(
      dispatch,
      getState,
      LOGIN,
      "login",
      {
        method: "post",
        body: JSON.stringify({ username: e, password: p }),
      },
      {
        success: () => {
          dispatch(getAPIBuildNumber());
        },
      },
    );
  };
};

export const validateSession = () => {
  return (dispatch, getState) => {
    callApi(dispatch, getState, SESSION, "login");
  };
};

export const getUserClients = (userId) => {
  return (dispatch, getState) => {
    callApi(dispatch, getState, USER_CLIENTS, `users/${userId}/clients`);
  };
};

export const getCurrentUserClients = () => {
  return (dispatch, getState) => {
    callApi(dispatch, getState, USER_CLIENTS, `clients/my`);
  };
};

export const getUserDetail = (userId) => {
  return (dispatch, getState) => {
    callApi(dispatch, getState, LOGIN_USER_DETAIL, `users/${userId}`);
  };
};

export const getUserAvatar = (fileName) => {
  return (dispatch, getState) => {
    callApi(dispatch, getState, USER_AVATAR, `avatars/${fileName}`);
  };
};

export const getCurrentUserProfile = () => {
  return (dispatch, getState) => {
    callApi(dispatch, getState, LOGIN_USER_DETAIL, `users/my-profile`);
  };
};

export const getCurrentUserOptimizeDetail = () => {
  return (dispatch, getState) => {
    callApi(
      dispatch,
      getState,
      OPTIMIZE_USER_DETAIL,
      `users/current`,
      {},
      {},
      true,
    );
  };
};

export const sendPasswordRecoveryEmail = (email, secretKey) => {
  return (dispatch, getState) => {
    callApi(
      dispatch,
      getState,
      SEND_PASSWORD_RECOVERY,
      "pub/send-recovery-link",
      {
        method: "post",
        body: JSON.stringify({ email: email, recaptchaResponse: secretKey }),
      },
    );
  };
};

export const resetPassword = (password, rePassword, requestKey) => {
  return (dispatch, getState) => {
    callApi(dispatch, getState, RESET_PASSWORD, "pub/reset-password", {
      method: "post",
      body: JSON.stringify({
        password: password,
        confirmPassword: rePassword,
        requestKey: requestKey,
      }),
    });
  };
};

export const getClientInfo = (id) => (dispatch, getState) => {
  let url = `clients/${id}`;

  callApi(
    dispatch,
    getState,
    GET_CLIENT_BYID,
    url,
    {},
    {
      failure: () => {
        window.location = "/dashboard";
      },
    },
  );
};



// WEBPACK FOOTER //
// ./src/actions/App.js